import React from 'react';
import './ndoeUi.css';
import './ndoeImage.css';

/**
 * NdoeDataCard — carte "ligne" pour les listes mobile (remplace une ligne de tableau).
 * Structure : [photo] + titre + sous-titre + badge, métriques, actions.
 *
 * Props :
 *  - media    : node (ex. <NdoeImage/>) — la PHOTO, affichée en tête de carte
 *  - title    : titre (ex. cliente / livreur / produit)
 *  - subtitle : sous-titre (ex. n° · téléphone · commune)
 *  - badge    : node (ex. <NdoeStatusBadge/>)
 *  - metrics  : tableau [{ label, value }] — 2 à 4 conseillés
 *  - actions  : node(s) (boutons tactiles)
 *  - onClick  : rend toute la carte cliquable (optionnel)
 *  - children : contenu additionnel avant les actions
 *  - className
 */
export default function NdoeDataCard({
  media,
  title,
  subtitle,
  badge,
  metrics = [],
  actions,
  onClick,
  children,
  className = '',
}) {
  const clickable = typeof onClick === 'function';
  return (
    <div
      className={`ndoe-mobile-card ${clickable ? 'is-clickable' : ''} ${className}`}
      onClick={onClick}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
    >
      <div className="ndoe-mobile-card__top">
        {media ? <div className="ndoe-mobile-card__media">{media}</div> : null}
        <div className="ndoe-mobile-card__main">
          <div className="ndoe-mobile-card__head">
            <div style={{ minWidth: 0 }}>
              {title ? <h3 className="ndoe-mobile-card__title">{title}</h3> : null}
              {subtitle ? <p className="ndoe-mobile-card__subtitle">{subtitle}</p> : null}
            </div>
            {badge ? <div>{badge}</div> : null}
          </div>

          {metrics && metrics.length ? (
            <div className="ndoe-mobile-card__metrics">
              {metrics.map((m, i) => (
                <span className="ndoe-mobile-card__metric" key={i}>
                  <b>{m.value}</b>
                  {m.label ? <small>{m.label}</small> : null}
                </span>
              ))}
            </div>
          ) : null}
        </div>
      </div>

      {children}

      {actions ? (
        <div
          className="ndoe-mobile-card__actions"
          onClick={(e) => e.stopPropagation()}  /* n'active pas onClick de la carte */
        >
          {actions}
        </div>
      ) : null}
    </div>
  );
}
